export default function createOfferStoreRequest(formData) {
  return {
    top_banner_id: formData?.topBannerId ?? null,
    bottom_banner_id: formData?.bottomBannerId ?? null,
    slug: formData.slug,
    name: formData.name,
    valid_from: formData.validFrom,
    valid_to: formData.validTo,
    is_countdown_enabled: formData.isCountdownEnabled,
    manager_id: formData.manager?.id ?? null,
    services: formData.services.map((discountService) => ({
      service_id: discountService.id,
      discount_percent: discountService.discountPercent / 100,
    })),
  };
}
